<div class="main-content">
  <div class="container-fluid">
    <div class="header-actions">
      <h4 class="card-title">Order Details</h4>
      <span class="header-buttons">
        @if (canPrintLabel) {
          <button mat-stroked-button (click)="printLabel()">
            <mat-icon>print</mat-icon>
            Print label
          </button>
        }
        <fh-refresh-button [onRefresh]="refreshOrder" />
      </span>
    </div>
    <div class="row">
      <div class="col-md-12">

        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Orders Basic Details</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-primary">Order-ID</th>
                    <th># {{ orderId }}</th>
                    @if (orderDetails.customer_name) {
                      <th class="text-primary">Customer Name</th>
                    }
                    @if (orderDetails.customer_name) {
                      <th class="text-capitalize">{{ orderDetails.customer_name }}</th>
                    }
                  </tr>
                  <tr>
                    @if (orderDetails.shipping_address) {
                      <th class="text-primary">Shipping Address</th>
                    }
                    @if (orderDetails.shipping_address) {
                      <th> {{ orderDetails.shipping_address }}</th>
                    }
                  </tr>
                  <tr>
                    <th class="text-primary">Sub Total</th>
                    <th>{{ orderDetails.currency }} {{ orderDetails.sub_total | number : '1.2-2' }}</th>
                  </tr>
                  <!-- Merchant Self Delivery: the merchant delivers this order, so
                       they see the delivery fee charged and the total. -->
                  @if (orderDetails.self_delivery) {
                    <tr>
                      <th class="text-primary">Delivery Fee</th>
                      <th>{{ orderDetails.currency }} {{ orderDetails.shipping_total | number : '1.2-2' }}</th>
                    </tr>
                    <tr>
                      <th class="text-primary">Total</th>
                      <th>{{ orderDetails.currency }} {{ orderDetails.total | number : '1.2-2' }}</th>
                    </tr>
                  }
                  <tr>
                    <th class="text-primary">Order On</th>
                    <th>{{ orderDetails.created_on | date : 'medium' }}</th>
                  </tr>
                  <!-- The customer's note to the merchant, and on its right the
                       merchant's to the customer (shown on their My Orders). -->
                  <tr>
                    <th class="text-primary">Customer Remarks</th>
                    <th class="remarks-cell">{{ orderDetails.remarks || '—' }}</th>
                    <th class="text-primary">Merchant Remarks for Customer</th>
                    <th class="remarks-cell">
                      <textarea
                        class="merchant-remarks"
                        rows="3"
                        maxlength="500"
                        [(ngModel)]="merchantRemarks"
                        (ngModelChange)="merchantRemarksSaved = false"
                        placeholder="Write updates for customers including delivery updates or delivery tracking number"
                        aria-label="Merchant Remarks for Customer"
                      ></textarea>
                      <div class="merchant-remarks-actions">
                        <span class="remarks-count">{{ merchantRemarks.length }}/500</span>
                        @if (merchantRemarksSaved) {
                          <span class="remarks-saved">Saved</span>
                        }
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="saveMerchantRemarks()"
                          [disabled]="savingMerchantRemarks || merchantRemarksSaved"
                        >
                          Save
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Orders Details (Product List)</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table" style="min-width: 760px;">
                <thead class="text-primary">
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Option</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Delivery Status</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of list; track row) {
                    <tr>
                      <td>{{ row.product_id }}</td>
                      <td class="text-capitalize">{{ row.product_name }}</td>
                      <td>
                        @if (row.product_image) {
                          <img
                            src="{{ row.product_image }}"
                            alt="Product Image"
                            width="80"
                            height="80"
                            />
                        }
                      </td>
                      <td>
                        {{ row.addon_name }} / {{ orderDetails.currency }}
                        {{ row.price | number : '1.2-2' }}
                      </td>
                      <td>{{ row.quantity }}</td>
                      <td>{{ row.productTotalPrice | number : '1.2-2' }}</td>
                      <td>
                        <fh-form-autocomplete
                          [options]="deliveryStatusOptions"
                          label=""
                          [(ngModel)]="row.delivery_status"
                          (ngModelChange)="updateItemDeliveryStatus(row)"
                        />
                      </td>
                      <td>
                        <input [(ngModel)]="row.remarks" />
                        <button mat-icon-button (click)="updateItemRemarks(row)">
                          <span>✓</span>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
